import { GetListParams, GetListResult } from 'react-admin';
import { getClientApi } from 'src/data-communication';
import { PositionDto, PrivateQuoteSnapDto } from 'src/dtos';
import { mapPositionListDtoToModel } from 'src/mappers';
import { Position, Quote } from 'src/models';

import { getQuoteList } from './quote.provider';

const clientApi = getClientApi();

export const getPositionList = async (params: GetListParams): Promise<GetListResult<Position>> => {
  const { accountId } = params.meta;
  let positions: Position[] = [];
  const { data } = await clientApi.position.list({
    params: {
      accountId,
    },
  });

  const symbols: string[] = data.map((aPositionDto: PositionDto) => aPositionDto.Symbol);

  let snapQuotes: Quote[] = [];

  try {
    if (symbols.length) {
      const response = await getQuoteList({
        meta: {
          symbols,
        },
      });
      // TODO: find out what's up with the snap quotes
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      snapQuotes = response.data;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching quote media.');
    // eslint-disable-next-line no-console
    console.error(error);
  }

  const { data: privateQuotes } = await clientApi.privateQuotes.list({
    queryParams: {},
  });

  let privateQuotesSnap: PrivateQuoteSnapDto[] = [];

  try {
    const privateSymbols = privateQuotes.map(aPrivateQuote => aPrivateQuote.symbol);

    if (privateSymbols.length) {
      const privateQuotesSnapResponse = await clientApi.privateQuotes.snap({
        queryParams: {
          symbols: privateSymbols,
        },
      });
      privateQuotesSnap = privateQuotesSnapResponse.data;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching private quotes snap.');
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return {
    data: mapPositionListDtoToModel(data, snapQuotes, privateQuotes, privateQuotesSnap),
    total: positions.length,
  };
};
